import { Button, Checkbox, Group, Modal, Stack, Text, TextInput } from "@mantine/core";
import { useState } from "react";
import { EndCustomerChargeApi } from "../../apis";

interface Props {
  opened: boolean;
  onClose: () => void;
  onSuccess: () => void;
}

interface RunResult {
  period: string;
  totalGenerated: number;
  totalSkipped: number;
  perComponent: Array<{ componentId: string; contractId: string; tenantId: string; generated: number; skipped: number }>;
  dryRun?: boolean;
}

export function BackfillRunModal({ opened, onClose, onSuccess }: Props) {
  const [period, setPeriod] = useState("");
  const [dryRun, setDryRun] = useState(true);
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const [result, setResult] = useState<RunResult | null>(null);

  const run = async () => {
    if (!/^\d{4}-\d{2}$/.test(period)) { setErr("Period YYYY-MM хэлбэрээр оруулна уу"); return; }
    setBusy(true); setErr(null); setResult(null);
    try {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const r = (await EndCustomerChargeApi.runBilling({ period, dryRun })) as any;
      setResult(r);
      if (!dryRun) onSuccess();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      setErr(e?.message ?? String(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal opened={opened} onClose={() => { setResult(null); setPeriod(""); onClose(); }} title="EC шимтгэлийг гараар үүсгэх" centered size="lg">
      <Stack>
        <TextInput
          label="Period (YYYY-MM)" required placeholder="2026-03"
          value={period}
          onChange={(e) => setPeriod(e.currentTarget.value)}
        />
        <Checkbox
          label="Dry-run (нэмж хадгалахгүй — тооцоо хэдийг ч гарахыг шалга)"
          checked={dryRun}
          onChange={(e) => setDryRun(e.currentTarget.checked)}
        />
        {err && <Text c="red" size="sm">{err}</Text>}
        {result && (
          <Stack gap="xs">
            <Text fw={600}>Үр дүн</Text>
            <Text>Period: {result.period}{result.dryRun ? " (dry-run)" : ""}</Text>
            <Text>Шинэ үүсгэсэн: {result.totalGenerated}</Text>
            <Text>Өмнө нь үүссэн (skip): {result.totalSkipped}</Text>
            {result.perComponent.length > 0 && (
              <Stack gap={4}>
                {result.perComponent.map((p) => (
                  <Text key={p.componentId} size="sm" c="dimmed">
                    {p.componentId.slice(0, 8)}... — generated {p.generated} / skipped {p.skipped}
                  </Text>
                ))}
              </Stack>
            )}
          </Stack>
        )}
        <Group justify="flex-end">
          <Button variant="default" onClick={onClose} disabled={busy}>Хаах</Button>
          <Button onClick={run} loading={busy}>Ажиллуулах</Button>
        </Group>
      </Stack>
    </Modal>
  );
}
